// Vocabulary: readers see this feature as "owner reviews"; code, routes, DealHunt paths and
// analytics events keep the historical "owner note" name on purpose — do not rename them.

import { SIGN_IN_GATE } from 'lib/owner-notes/band-copy'
import styles from './OwnerNoteBand.module.css'

interface SignInGatePanelProps {
  /** Email sign-in is offered in the dialog (commentHub said so): only then the email-link hint
   *  shows. The lead names no method (2026-10-17) and never waits for this. */
  emailOffered: boolean
  /** Why the last Publish stopped (`GATE_LINK_FAILED`, the expired line), when it did. */
  stopped?: string | null
  /** This browser's device is already linked (`me.profile.claimed`): its handle. The lead names
   *  it and asks the reader to confirm it is them — the gate is a live session (2026-10-17). */
  linkedHandle?: string | null
  /** Rendered as the footer of the band's own preview card (no `hostPanels`, 2026-10-17): no
   *  box of its own, and the linked lead drops "Publishes as @x." — the card's byline names it. */
  inPreview?: boolean
}

/**
 * The sign-in gate at step 3 (`lib/owner-notes/signin-gate.ts`, gated creates only). In the
 * band's own step 3 it is the footer of the "How it appears in the community" preview card
 * (`inPreview`), under the byline that already names the reader; with `hostPanels` (the
 * community composer renders its own preview) it keeps the standalone box in the identity row's
 * style, right under the sentence. It holds no button — the band's primary button reads "Sign in
 * to publish" and is the one sign-in action in the form (the photo block drops its own). Signing
 * in only opens the dialog; nothing links until the reader clicks Publish (#81, 49cebd39).
 */
const SignInGatePanel: React.VFC<SignInGatePanelProps> = ({
  emailOffered,
  stopped = null,
  linkedHandle = null,
  inPreview = false,
}) => {
  let lead: string = SIGN_IN_GATE.lead
  if (linkedHandle) {
    lead = inPreview ? SIGN_IN_GATE.confirmLead : SIGN_IN_GATE.linkedLead(linkedHandle)
  }
  return (
    <div className={inPreview ? undefined : styles.identity} role="status">
      {stopped && <p className={styles.gateStopped}>{stopped}</p>}
      <p className={styles.gateLead}>{lead}</p>
      {emailOffered && <p className={styles.gateHint}>{SIGN_IN_GATE.linkHint}</p>}
    </div>
  )
}

export default SignInGatePanel
